import { getUserToken } from "./localServices";

const fetchApi = async ({ endpoint, params = {}, query = {}, body = {} }) => {
  // Validate the request based on the API definition
  // validateRequest({ endpoint, params, query, body });

  if (!endpoint) {
    throw new Error(`API definition not found.`);
  }

  let url = endpoint.url();

  // Replace dynamic parts of the URL (e.g., :taskId)
  if (params && Object.keys(params).length > 0) {
    for (const [key, value] of Object.entries(params)) {
      url = url.replace(`:${key}`, value);
    }
  }

  // Add query parameters to the URL
  const queryString = new URLSearchParams(query).toString();
  if (queryString) {
    url = `${url}?${queryString}`;
  }

  // Determine if the body is a FormData instance (for file uploads)
  const isFormData = body instanceof FormData;

  // Set up request options
  const options = {
    method: endpoint.method?.toUpperCase() || "GET",
    headers: {
      Authorization: `Bearer ${getUserToken()}`,
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    },
  };

  // Add body only for methods like POST/PUT/PATCH
  if (["POST", "PUT", "PATCH"].includes(options.method)) {
    options.body = isFormData ? body : JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);

    // Check if the response is JSON
    const contentType = response.headers.get("content-type");
    const jsonResponse = contentType?.includes("application/json") ? await response.json() : await response.text();

    if (checkUnAuthorisedRequest(jsonResponse)) {
      return jsonResponse;
    }
  } catch (error) {
    throw error;
  }
};

// Adds defaults or validates missing fields
// const validateRequest = ({ endpoint, params = {}, query = {}, body = {} }) => {
//   // Fill in missing query parameters from endpoint definition
//   if (endpoint?.queryParams) {
//     endpoint.queryParams.forEach((param) => {
//       if (query[param] === undefined && params[param] === undefined) {
//         query[param] = "";
//       }
//     });
//   }

//   // Fill in missing dynamic route params
//   if (endpoint?.params) {
//     endpoint.params.forEach((param) => {
//       if (params[param] === undefined) {
//         params[param] = "";
//       }
//     });
//   }

//   // Fill in missing body fields for POST/PUT
//   if (["POST", "PUT"].includes(endpoint?.method) && endpoint?.body) {
//     endpoint.body.forEach((field) => {
//       if (body[field] === undefined) {
//         body[field] = "";
//       }
//     });
//   }

//   return { params, query, body };
// };

// Check if login redirection is needed
const checkUnAuthorisedRequest = (response) => {
  if (typeof response === "object" && response?.data?.redirect === "/login") {
    handleRedirection();
    return false;
  }
  return true;
};

// Redirect to login with original URL
const handleRedirection = () => {
  const currentUrl = window.location.href;
  const urlParams = new URLSearchParams(window.location.search);

  // Prevent recursive redirection
  if (!urlParams.has("redirect")) {
    window.history.pushState({}, "", `/?redirect=${encodeURIComponent(currentUrl)}`);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
};

export default fetchApi;
